/**
 * The buttons to control the survey dialog
 */
import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";

const SurveyDialogButtons = (props) => {
  const {
    questions,
    questionIndex,
    handleBackClick,
    isEndOfSurvey,
    handleNextClick,
    isValid,
  } = props;

  return (
    <Fragment>
      {!isEndOfSurvey && questions[questionIndex + 1] && (
        <div className={"justify-content-center"}>
          <Button
            variant="primary"
            onClick={handleNextClick}
            disabled={!isValid}
            id={"surveyNextBtn"}
          >
            Next
          </Button>
        </div>
      )}
      {(questionIndex === questions.length - 1 || isEndOfSurvey) && (
        <div className={"justify-content-center"}>
          <Button
            variant="primary"
            type={"submit"}
            disabled={!isValid}
            id={"surveySubmitBtn"}
          >
            Submit
          </Button>
        </div>
      )}
      {questionIndex > 0 && (
        <div className={"justify-content-center"}>
          <Button variant="link" onClick={handleBackClick} id={"surveyBackBtn"}>
            Back
          </Button>
        </div>
      )}
    </Fragment>
  );
};

SurveyDialogButtons.propTypes = {
  questions: PropTypes.array,
  questionIndex: PropTypes.number.isRequired,
  handleBackClick: PropTypes.func.isRequired,
  isEndOfSurvey: PropTypes.bool.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
};

export default SurveyDialogButtons;
